import { Flex, Tabs, Rate, List, Avatar, Space, Button } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/it";
import { useState, useMemo } from "react";

const ReviewsList = ({ reviews }: { reviews: {
    id: number;
    professionist: number;
    comment: string;
    updated_at: string;
    patient: {
      name: string;
    };
  }[]
}) => {
  const [sortBy, setSortBy] = useState<"recent" | "highest" | "lowest" | null>(null);

  const sortedReviews = useMemo(() => {
    const sorted = [...reviews];
    switch (sortBy) {
      case "recent":
        return sorted.sort(
          (a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
        );
      case "highest":
        return sorted.sort((a, b) => b.professionist - a.professionist);
      case "lowest":
        return sorted.sort((a, b) => a.professionist - b.professionist);
      default:
        return sorted;
    }
  }, [reviews, sortBy]);

  return (
    <Flex vertical gap={16}>
      <Space>
        <Button
          type={sortBy === "recent" ? "primary" : "dashed"}
          onClick={() => setSortBy(sortBy === "recent" ? null : "recent")}
        >
          Piu recente
        </Button>
        <Button
          type={sortBy === "highest" ? "primary" : "dashed"}
          onClick={() => setSortBy(sortBy === "highest" ? null : "highest")}
        >
          Punteggio piu alto
        </Button>
        <Button
          type={sortBy === "lowest" ? "primary" : "dashed"}
          onClick={() => setSortBy(sortBy === "lowest" ? null : "lowest")}
        >
          Punteggio piu basso
        </Button>
      </Space>
      <List
        itemLayout="horizontal"
        dataSource={sortedReviews}
        pagination={{
          pageSize: 3,
        }}
        renderItem={(item) => (
          <List.Item>
            <Flex gap={16}>
              <Avatar style={{ backgroundColor: "#fde3cf", color: "#f56a00" }}>{item?.patient?.name?.charAt(0).toUpperCase()}</Avatar>
              <Flex vertical key={item.id}>
                <span style={{ lineHeight: "32px", display: "block" }}>{item?.patient?.name}</span>
                <Rate disabled value={item.professionist} className="text-xs text-[#54C8C1]" />
                <div className="text-xs text-gray-500">{dayjs(item.updated_at).locale("it").format("D MMMM YYYY")}</div>
                <div>{item.comment}</div>
              </Flex>
            </Flex>
          </List.Item>
        )}
      />
    </Flex>
  );
};

const Reviews = ({ reviews }: { reviews: {
  id: number;
  professionist: number;
  comment: string;
  updated_at: string;
  patient: {
    name: string;
  };
}[] }) => {
  const positiveReviews = reviews.filter((review) => review.professionist > 3);
  const neutralReviews = reviews.filter((review) => review.professionist === 3);
  const negativeReviews = reviews.filter((review) => review.professionist < 3);

  return (
    <Tabs
      defaultActiveKey="1"
      items={[
        {
          label: `Tutte le recensioni (${reviews.length})`,
          key: "1",
          children: <ReviewsList reviews={reviews} />,
        },
        {
          label: `Positive (${positiveReviews.length})`,
          key: "2",
          children: <ReviewsList reviews={positiveReviews} />,
        },
        {
          label: `Neutrali (${neutralReviews.length})`,
          key: "3",
          children: <ReviewsList reviews={neutralReviews} />,
        },
        {
          label: `Negative (${negativeReviews.length})`,
          key: "4",
          children: <ReviewsList reviews={negativeReviews} />,
        },
      ]}
    />
  );
};

export default Reviews;
